import { breakpoints } from "@tvg/design-system";
import styled from "styled-components";

export const Container = styled.section`
  border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};

  @media screen and ${breakpoints.tablet.max.sm} {
    margin-top: ${({ theme }) => theme.space["space-4"]};
  }
`;

export const RaceInfoContainer = styled.div`
  padding: 0 ${({ theme }) => theme.space["space-4"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }
`;
